import { render, staticRenderFns } from "./PrestadoresServicoFilter.vue?vue&type=template&id=c66295f8&"
import script from "./PrestadoresServicoFilter.vue?vue&type=script&lang=js&"
export * from "./PrestadoresServicoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
